<template>
	<card bg="bg-dark text-white" title="Muestras Asociadas">
		<card title="Nuevo Producto">
			<div v-if="detailNew.length > 0" class="table-responsive">
				<div v-for="item in detailNew" :key="item.id">
					<div style="margin-bottom: 50px !important;" class="card cardShadow">
						<div class="card-header">
							<div class="row">
								<div class="col-md-10">
									<h5 class="card-title d-inline"><b>VINO: {{ item.variety }} {{
										item.valley }} {{ item.quality }}</b></h5>
								</div>
								<div class="col-md-2 text-right">
									<div v-if="item.cancelledAt == null &&
										item.rejectAt == null &&
										item.rejectToWinderyDispatch == null
									" :id="'options-butons-' + item.id">
										<button v-if="item.inRevision ||
											item.stage === 'Creado'
										" class="btn btn-danger btn-sm" title="Eliminar Muestra" @click.prevent="deleteId = item.id">
											<i class="fa fa-trash"></i>
										</button>
										<button v-if="item.inRevision ||
											item.stage === 'Creado'
										" class="btn btn-info btn-sm ml-2" title="Editar Muestra" @click.prevent="editItem = item">
											<i class="far fa-edit"></i>
										</button>
										<button v-if="item.inRevision ||
											item.stage === 'Creado'
										" class="btn btn-danger btn-sm ml-2" title="Cancelar Muestra" @click="cancelItem(item.id)">
											<i class="fa fa-times"></i>
										</button>
									</div>
								</div>
							</div>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-md-12 text-right">
									<div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
										<h4>
											<b><span :class="'badge ribbon-h-' + item.statusColor"
													:id="'status-text-' + item.id">
													<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
												</span></b>
										</h4>
									</div>
								</div>
								<div class="col-md-12">
									<table class="table table-striped table-bordered">
										<thead style="background-color: #6c757d; color: white">
											<tr>
												<th>Marca</th>
												<th v-if="item.comercialMixCode != null" style="width: 20%">
													Mezcla Comercial
												</th>
												<th>Vino</th>
												<th class="text-center" style="width: 8%">Botellas</th>
											</tr>
										</thead>
										<tbody>
											<tr style="font-size: 20px !important;">
												<td>
													<span class="badge badge-info p-2">{{ item.brand }}</span>
												</td>
												<td v-if="item.comercialMixCode != null">
													<span class="badge badge-info p-2">{{ item.comercialMix }} -{{
														item.comercialMixCode }}</span>
												</td>
												<td>
													<span class="badge badge-info p-2">{{ item.variety }}</span>
													<span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
													<span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
												</td>
												<td class="text-center">
													<span class="badge badge-success p-2">{{ item.quantity }}</span>
												</td>
											</tr>
										</tbody>
									</table>
									<table class="table table-striped table-bordered">
										<thead style="background-color: #6c757d; color: white">
											<tr class="text-center">
												<th>Muestra Enológica</th>
												<th>Con Degustación</th>
												<th>Con Cosecha Histórica/Próxima</th>
												<th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
											</tr>
										</thead>
										<tbody>
											<tr class="text-center" style="font-size: 20px !important;">
												<td>
													<i v-if="item.wineSample" class="fa fa-check text-success"></i>
													<i v-if="!item.wineSample" class="fa fa-times text-danger"></i>
												</td>
												<td>
													<i v-if="item.withTasting" class="fa fa-check text-success"></i>
													<i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
												</td>
												<td>
													<i v-if="item.isHistoricalOrUpcoming"
														class="fa fa-check text-success"></i>
													<i v-if="!item.isHistoricalOrUpcoming"
														class="fa fa-times text-danger"></i>
												</td>
												<td>
													<span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div v-if="item.rejectionReason" class="card mb-4 bg-danger">
								<div class="card-body">
									<span class="text-white"><b>Motivo de rechazo: </b> {{ item.rejectionReason
									}}</span>
								</div>
							</div>
							<div v-if="item.rejectionWineryDispatchReason" class="card mb-4 bg-danger">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo:</b>
										{{ item.rejectionWineryDispatchReason }}
									</span>
								</div>
							</div>
							<div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo Cancelación:</b> {{ item.cancelledReason }}
									</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-7">
									<table class="table table-striped table-hover table-bordered">
										<thead class="thead-dark">
											<tr>
												<th colspan="3">Componentes Asociados
												</th>
											</tr>
										</thead>
										<thead class="thead-light">
											<tr>
												<th style="width: 20%">Capsula</th>
												<td style="width: 14%">{{ item.capsuleCode }}</td>
												<td>{{ item.capsuleName }}</td>
											</tr>
											<tr>
												<th>Tapa</th>
												<td>{{ item.cappingCode }}</td>
												<td>{{ item.cappingName }}</td>
											</tr>
											<tr>
												<th>Caja</th>
												<td>{{ item.boxCode }}</td>
												<td>{{ item.boxName }}</td>
											</tr>
											<tr>
												<th>Botella</th>
												<td>{{ item.bottleCode }}</td>
												<td>{{ item.bottleName }}</td>
											</tr>
											<tr>
												<th>Etiqueta</th>
												<td>{{ item.labelCode }}</td>
												<td>{{ item.labelName }}</td>
											</tr>
											<tr>
												<th>Contraetiqueta</th>
												<td>{{ item.backLabelCode }}</td>
												<td>{{ item.backLabelName }}</td>
											</tr>
											<tr v-if="item.otherSemiElaborateCode"
												style="color: white; background-color: #6c757d">
												<td colspan="3"><span class="mr-4">Otro Semielaborado:</span></td>
											</tr>
											<tr v-if="item.otherSemiElaborateCode">
												<td>{{ item.otherSemiElaborateCode }}</td>
												<td colspan="2">{{ item.otherSemiElaborateName }}</td>
											</tr>
										</thead>
									</table>
								</div>
								<div v-if="item.isNewComposition == true" class="col-md-5">
									<table class="table table-striped table-hover table-bordered">
										<thead class="thead-dark">
											<tr>
												<th colspan="2">Nueva Composición</th>
											</tr>
										</thead>
										<thead class="thead-light">
											<tr>
												<th>Variedad</th>
												<th style="width: 20%">Porcentaje %</th>
											</tr>
											<tr v-for="composition in item.compositionDetails" :key="composition.id">
												<td>
													{{ composition.variety }}
												</td>
												<td>
													{{ composition.percent }}
												</td>
											</tr>
										</thead>
									</table>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-striped table-hover table-bordered">
										<thead class="thead-light">
											<tr>
												<th style="width:25%">Obs. Preparación del Vino</th>
												<td>{{ item.preparationRemarks }}</td>
											</tr>
											<tr>
												<th>Glosa Sticker</th>
												<td>{{ item.stickerGloss }}</td>
											</tr>
											<tr>
												<th>Confección Packaging</th>
												<td>{{ item.confectionRemarks }}</td>
											</tr>
										</thead>
									</table>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Observaciones Adicionales</th>
											</tr>
											<tr v-if="item.requestDetailObservations">
												<th style="width: 18%">Fecha</th>
												<th style="width: 12%">Usuario</th>
												<th style="width: 70%">Observación</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="observation in item.requestDetailObservations"
												:key="observation.id">
												<td>{{ observation.createdAtString }}</td>
												<td>{{ observation.email }}</td>
												<td>{{ observation.observation }}</td>
											</tr>
											<tr>
												<td colspan="3">
													<div class="row">
														<div class="col-10">
															<input class="form-control"
																:id="'observation-input-' + item.id" type="text" />
														</div>
														<div class="col-2">
															<button class="btn btn-success float-right"
																@click="addObservation(item.id)">
																<i class="fa fa-save"></i>
																<span class="ml-2">Registrar Observación</span>
															</button>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="5">Documentos Adjuntos</th>
											</tr>
											<tr v-if="item.documentFiles.length > 0">
												<th style="width: 18%">Usuario</th>
												<th style="width: 12%">Fecha de Carga</th>
												<th style="width: 54%">Nombre del Archivo</th>
												<th style="width: 8%">Tipo de Archivo</th>
												<th style="width: 8%">Opciones</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="doc in item.documentFiles" :key="doc.id">
												<td>{{ doc.email }}</td>
												<td>{{ doc.createdAtString }}</td>
												<td>{{ doc.fileName }}</td>
												<td style="font-size: 20px">
													<span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
															aria-hidden="true" class="fas fa-file-pdf"></i></span>
													<span v-if="doc.fileExtension == '.jpg' ||
														doc.fileExtension == '.png'
													" class="text-info"><i aria-hidden="true" class="fas fa-image"></i></span>
													<span v-if="doc.fileExtension == '.xls' ||
														doc.fileExtension == '.xlsx'
													" class="text-success"><i aria-hidden="true" class="fas fa-file-excel"></i></span>
													<span v-if="doc.fileExtension == '.doc' ||
														doc.fileExtension == '.docx'
													" class="text-primary"><i class="fas fa-file-word"></i></span>
												</td>
												<td class="text-right">
													<button class="btn btn-sm btn-success mr-2"
														@click="downloadFile(doc.id)">
														<i class="fa fa-download"></i>
													</button>
													<button class="btn btn-sm btn-danger" @click="deleteFile(doc.id)">
														<i class="fa fa-trash"></i>
													</button>
												</td>
											</tr>
											<tr v-if="!item.rejectToWinderyDispatch">
												<td colspan="4">
													<input :id="'file-input-' + item.id" type="file" />
												</td>
												<td>
													<button class="btn btn-sm btn-success" @click="uploadFile(item.id)">
														<i class="fa fa-save"></i>
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="row">
								<div v-if="item.inRevision" class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Historial de Revisión</th>
											</tr>
											<tr>
												<th style="width: 20%">Fecha de Envío a Revisión</th>
												<th style="width: 20%">Usuario</th>
												<th style="width: 60%">Razón</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="revision in item.requestChangeFlowHistories" :key="revision.id">
												<td>{{ revision.createdAtString }}</td>
												<td>{{ revision.user }}</td>
												<td>{{ revision.reason }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<modal-delete ref="modalDelete" @deleteItem="deleteItem" />
			</div>
			<alert v-else message="Aún no se registran muestras" />
		</card>
		<card title="Producto Terminado">
			<div v-if="detailFinish.length > 0" class="table-responsive">
				<div v-for="item in detailFinish" :key="item.id">
					<div style="margin-bottom: 50px !important;" class="card cardShadow">
						<div class="card-header">
							<div class="row">
								<div class="col-md-10">
									<h5 class="card-title d-inline"><b>SKU: {{ item.sku }}</b></h5>
								</div>
								<div class="col-md-2 text-right">
									<div v-if="item.cancelledAt == null &&
										item.rejectAt == null &&
										item.rejectToWinderyDispatch == null
									" :id="'options-butons-' + item.id">
										<button v-if="item.inRevision ||
											item.stage === 'Creado'
										" class="btn btn-danger btn-sm" title="Eliminar Muestra" @click.prevent="deleteId = item.id">
											<i class="fa fa-trash"></i>
										</button>

										<button v-if="item.inRevision ||
											item.stage === 'Creado'
										" class="btn btn-info btn-sm ml-2" title="Editar Muestra" @click.prevent="editItem = item">
											<i class="far fa-edit"></i>
										</button>
										<button v-if="item.inRevision ||
											item.stage === 'Creado'
										" class="btn btn-danger btn-sm ml-2" title="Cancelar Muestra" @click="cancelItem(item.id)">
											<i class="fa fa-times"></i>
										</button>
									</div>
								</div>
							</div>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-md-12 text-right">
									<div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
										<h4>
											<b><span :class="'badge ribbon-h-' + item.statusColor"
													:id="'status-text-' + item.id">
													<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
												</span></b>
										</h4>
									</div>
								</div>
								<div class="col-md-12">
									<table class="table table-striped table-hover table-bordered">
										<thead style="background-color: #6c757d; color: white">
											<tr>
												<th>Sku</th>
												<th>Marca</th>
												<th v-if="item.comercialMixCode != null">
													Mezcla Comercial
												</th>
												<th>Vino</th>
												<th class="text-center" style="width: 8%">Botellas</th>
											</tr>
										</thead>
										<tbody>
											<tr style="font-size: 20px !important;">
												<td>
													<span class="badge badge-info p-2">{{ item.sku }}</span>
												</td>
												<td>
													<span class="badge badge-info p-2">{{ item.brand }}</span>
												</td>
												<td v-if="item.comercialMixCode != null">
													<span class="badge badge-info p-2">{{ item.comercialMix }} -{{
														item.comercialMixCode }}</span>
												</td>
												<td>
													<span class="badge badge-info p-2">{{ item.variety }}</span>
													<span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
													<span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
												</td>
												<td class="text-center">
													<span class="badge badge-success p-2">{{ item.quantity }}</span>
												</td>
											</tr>
										</tbody>
									</table>
									<table class="table table-striped table-bordered">
										<thead style="background-color: #6c757d; color: white">
											<tr class="text-center">
												<th>Muestra Enológica</th>
												<th>Con Degustación</th>
												<th>Requiere Trasvasije</th>
												<th>Vino No Real</th>
												<th>No Maquetar</th>
												<th>Con Cosecha Histórica/Próxima</th>
												<th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
											</tr>
										</thead>
										<tbody>
											<tr class="text-center" style="font-size: 20px !important;">
												<td>
													<i v-if="item.wineSample" class="fa fa-check text-success"></i>
													<i v-if="!item.wineSample" class="fa fa-times text-danger"></i>
												</td>
												<td>
													<i v-if="item.withTasting" class="fa fa-check text-success"></i>
													<i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
												</td>
												<td>
													<i v-if="item.requireTransfer" class="fa fa-check text-success"></i>
													<i v-if="!item.requireTransfer" class="fa fa-times text-danger"></i>
												</td>
												<td>
													<i v-if="item.notRealWine" class="fa fa-check text-success"></i>
													<i v-if="!item.notRealWine" class="fa fa-times text-danger"></i>
												</td>
												<td>
													<i v-if="item.notLayout" class="fa fa-check text-success"></i>
													<i v-if="!item.notLayout" class="fa fa-times text-danger"></i>
												</td>
												<td>
													<i v-if="item.isHistoricalOrUpcoming"
														class="fa fa-check text-success"></i>
													<i v-if="!item.isHistoricalOrUpcoming"
														class="fa fa-times text-danger"></i>
												</td>
												<td>
													<span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div v-if="item.rejectionReason" class="card mb-4 bg-danger">
								<div class="card-body">
									<span class="text-white"><b>Motivo de rechazo: </b> {{ item.rejectionReason
									}}</span>
								</div>
							</div>
							<div v-if="item.rejectionWineryDispatchReason" class="card mb-4 bg-danger">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo:</b>
										{{ item.rejectionWineryDispatchReason }}
									</span>
								</div>
							</div>
							<div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo Cancelación:</b> {{ item.cancelledReason }}
									</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<table class="table table-striped table-hover table-bordered">
										<thead class="thead-dark">
											<tr>
												<th colspan="4">
													<div class="row">
														<div class="col-md-6">
															Componentes Asociados
														</div>
														<div class="col-md-6 text-right">
															<span v-if="item.saleZoneCode != null">Zona de venta: {{
																item.saleZone }}</span>
														</div>
													</div>
												</th>
											</tr>
										</thead>
										<thead class="thead-light">
											<tr>
												<th style="width: 8%;">Posición</th>
												<th style="width: 15%">Código</th>
												<th>Componente</th>
											</tr>
										</thead>
										<tr v-for="lc in item.components" :key="lc.id">
											<td>{{ lc.componentPosition }}</td>
											<td>
												{{ lc.name.split(" - ")[1] }}
											</td>
											<td>
												{{ lc.name.split(" - ")[0] }}
											</td>
										</tr>
									</table>
									<table class="table table-striped table-bordered">
										<thead class="thead-dark">
											<tr>
												<th colspan="4">Semielaborado:</th>
											</tr>
										</thead>
										<tr>
											<td colspan="2">{{ item.semiElaborateCode }}</td>
											<td>{{ item.semiElaborateName }}</td>
										</tr>
										<tr v-if="item.otherSemiElaborateCode"
											style="color: white; background-color: #6c757d">
											<td colspan="4"><span class="mr-4">Otro Semielaborado:</span></td>
										</tr>
										<tr v-if="item.otherSemiElaborateCode">
											<td colspan="2">{{ item.otherSemiElaborateCode }}</td>
											<td>{{ item.otherSemiElaborateName }}</td>
										</tr>
									</table>
								</div>
								<div class="col-md-6">
									<table class="table table-striped table-hover table-bordered">
										<thead class="thead-light">
											<tr>
												<th style="width:25%">Glosa Sticker</th>
												<td>{{ item.stickerGloss }}</td>
											</tr>
											<tr>
												<th>Confección Packaging</th>
												<td>{{ item.confectionRemarks }}</td>
											</tr>
										</thead>
									</table>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Observaciones Adicionales</th>
											</tr>
											<tr v-if="item.requestDetailObservations">
												<th style="width: 18%">Fecha</th>
												<th style="width: 12%">Usuario</th>
												<th style="width: 70%">Observación</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="observation in item.requestDetailObservations"
												:key="observation.id">
												<td>{{ observation.createdAtString }}</td>
												<td>{{ observation.email }}</td>
												<td>{{ observation.observation }}</td>
											</tr>
											<tr>
												<td colspan="3">
													<div class="row">
														<div class="col-10">
															<input class="form-control"
																:id="'observation-input-' + item.id" type="text" />
														</div>
														<div class="col-2">
															<button class="btn btn-success float-right"
																@click="addObservation(item.id)">
																<i class="fa fa-save"></i>
																<span class="ml-2">Registrar Observación</span>
															</button>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="5">Documentos Adjuntos</th>
											</tr>
											<tr v-if="item.documentFiles.length > 0">
												<th style="width: 18%">Usuario</th>
												<th style="width: 12%">Fecha de Carga</th>
												<th style="width: 54%">Nombre del Archivo</th>
												<th style="width: 8%">Tipo de Archivo</th>
												<th style="width: 8%">Opciones</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="doc in item.documentFiles" :key="doc.id">
												<td>{{ doc.email }}</td>
												<td>{{ doc.createdAtString }}</td>
												<td>{{ doc.fileName }}</td>
												<td style="font-size: 20px">
													<span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
															aria-hidden="true" class="fas fa-file-pdf"></i></span>
													<span v-if="doc.fileExtension == '.jpg' ||
														doc.fileExtension == '.png'
													" class="text-info"><i aria-hidden="true" class="fas fa-image"></i></span>
													<span v-if="doc.fileExtension == '.xls' ||
														doc.fileExtension == '.xlsx'
													" class="text-success"><i aria-hidden="true" class="fas fa-file-excel"></i></span>
													<span v-if="doc.fileExtension == '.doc' ||
														doc.fileExtension == '.docx'
													" class="text-primary"><i class="fas fa-file-word"></i></span>
												</td>
												<td>
													<button class="btn btn-sm btn-success mr-2"
														@click="downloadFile(doc.id)">
														<i class="fa fa-download"></i>
													</button>
													<button class="btn btn-sm btn-danger" @click="deleteFile(doc.id)">
														<i class="fa fa-trash"></i>
													</button>
												</td>
											</tr>
											<tr v-if="!item.rejectToWinderyDispatch">
												<td colspan="5">
													<div class="row">
														<div class="col-10">
															<input :id="'file-input-' + item.id" type="file" />
														</div>
														<div class="col-2">
															<button class="btn btn-success float-right"
																@click="uploadFile(item.id)">
																<i class="fas fa-cloud-upload-alt"></i>
																<span class="ml-2">Cargar Documento</span>
															</button>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="row">
								<div v-if="item.inRevision && item.requestChangeFlowHistories" class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="4">Historial de Revisión</th>
											</tr>
											<tr>
												<th style="width: 10%">Fecha de Envío a Revisión</th>
												<th style="width: 16%">Usuario</th>
												<th>Razón</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="revision in item.requestChangeFlowHistories" :key="revision.id">
												<td>{{ revision.createdAtString }}</td>
												<td>{{ revision.user }}</td>
												<td v-if="revision.requestChangeFlowHistoryComponents">
													<p>{{ revision.reason }}</p>
													<table class="table table-sm table-stripped table-bordered">
														<thead class="thead-light">
															<tr>
																<th colspan="4">Sugerencia de Componentes</th>
															</tr>
															<tr>
																<th>Componente de Origen</th>
																<th>Componente Sugerido</th>
																<th>Año Cosecha</th>
																<th>Zona de Venta</th>
															</tr>
														</thead>
														<tr v-for="component in revision.requestChangeFlowHistoryComponents"
															:key="component.id">
															<td>{{ component.originComponentName }}</td>
															<td>{{ component.suggestedComponentName }} - {{
																component.suggestedComponentCode }}</td>
															<td>{{ component.suggestedHarvest }}</td>
															<td>{{ component.suggestedSaleZone }}</td>
														</tr>
													</table>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<alert v-else message="Aún no se registran muestras" />
		</card>
		<!-- El card de Guarda Botella/Semielaborado solo se muestra si existen registros antiguos de este tipo. -->
		<card title="Producto Guarda Botella" v-if="detailBottle.length > 0">
			<div v-if="detailBottle.length > 0" class="table-responsive">
				<div v-for="item in detailBottle" :key="item.id">
					<div style="margin-bottom: 50px !important;" class="card cardShadow">
						<div class="card-header">
							<div class="row">
								<div class="col-md-10">
									<h5 class="card-title d-inline"><b>CÓDIGO: {{ item.sku }}</b></h5>
								</div>
								<div class="col-md-2 text-right">
									<div v-if="item.cancelledAt == null &&
										item.rejectAt == null &&
										item.rejectToWinderyDispatch == null
									" :id="'options-butons-' + item.id">
										<button v-if="item.inRevision ||
											item.stage === 'Creado'
										" class="btn btn-danger btn-sm" title="Eliminar Muestra" @click.prevent="deleteId = item.id">
											<i class="fa fa-trash"></i>
										</button>

										<button v-if="item.inRevision ||
											item.stage === 'Creado'
										" class="btn btn-info btn-sm ml-2" title="Editar Muestra" @click.prevent="editItem = item">
											<i class="far fa-edit"></i>
										</button>
										<button v-if="item.inRevision ||
											item.stage === 'Creado'
										" class="btn btn-danger btn-sm ml-2" title="Cancelar Muestra" @click="cancelItem(item.id)">
											<i class="fa fa-times"></i>
										</button>
									</div>
								</div>
							</div>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-md-12 text-right">
									<div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
										<h4>
											<b><span :class="'badge ribbon-h-' + item.statusColor"
													:id="'status-text-' + item.id">
													<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
												</span></b>
										</h4>
									</div>
								</div>
								<div class="col-md-12">
									<table class="table table-striped table-hover table-bordered">
										<thead style="background-color: #6c757d; color: white">
											<tr>
												<th>Código</th>
												<th>Marca</th>
												<th>Mezcla Comercial</th>
												<th>Vino</th>
												<th>Cosecha</th>
												<th class="text-center" style="width: 8%">Botellas</th>
											</tr>
										</thead>
										<tbody>
											<tr style="font-size: 20px !important;">
												<td>
													<span class="badge badge-info p-2">{{ item.sku }}</span>
												</td>
												<td>
													<span class="badge badge-info p-2">{{ item.brand }}</span>
												</td>
												<td>
													<span class="badge badge-info p-2">{{ item.comercialMix }} -{{
														item.comercialMixCode }}</span>
												</td>
												<td>
													<span class="badge badge-info p-2">{{ item.variety }}</span>
													<span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
													<span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
												</td>
												<td>
													<span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
												</td>
												<td class="text-center">
													<span class="badge badge-success p-2">{{ item.quantity }}</span>
												</td>
											</tr>
										</tbody>
									</table>
									<table class="table table-striped table-hover table-bordered">
										<thead style="background-color: #6c757d; color: white">
											<tr class="text-center">
												<th>Con Degustación</th>
												<th>Requiere Trasvasije</th>
												<th>Con Cosecha Histórica/Próxima</th>
												<th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
											</tr>
										</thead>
										<tbody>
											<tr class="text-center" style="font-size: 20px !important;">
												<td>
													<i v-if="item.withTasting" class="fa fa-check text-success"></i>
													<i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
												</td>
												<td>
													<i v-if="item.requireTransfer" class="fa fa-check text-success"></i>
													<i v-if="!item.requireTransfer" class="fa fa-times text-danger"></i>
												</td>
												<td>
													<i v-if="item.isHistoricalOrUpcoming"
														class="fa fa-check text-success"></i>
													<i v-if="!item.isHistoricalOrUpcoming"
														class="fa fa-times text-danger"></i>
												</td>
												<td>
													<span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div v-if="item.rejectionReason" class="card mb-4 bg-danger">
								<div class="card-body">
									<span class="text-white"><b>Motivo de rechazo: </b> {{ item.rejectionReason
									}}</span>
								</div>
							</div>
							<div v-if="item.rejectionWineryDispatchReason" class="card mb-4 bg-danger">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo:</b>
										{{ item.rejectionWineryDispatchReason }}
									</span>
								</div>
							</div>
							<div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
								<div class="card-body">
									<span class="text-white">
										<b>Motivo Cancelación:</b> {{ item.cancelledReason }}
									</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<table class="table table-striped table-hover table-bordered">
										<thead class="thead-dark">
											<tr>
												<th colspan="3">Componentes Asociados
												</th>
											</tr>
										</thead>
										<thead class="thead-light">
											<tr v-if="item.capsuleName">
												<th style="width: 8%">Capsula</th>
												<td style="width: 15%">{{ item.capsuleCode }}</td>
												<td>{{ item.capsuleName }}</td>
											</tr>
											<tr v-if="item.cappingName">
												<th style="width: 8%">Tapa</th>
												<td style="width: 15%">{{ item.cappingCode }}</td>
												<td>{{ item.cappingName }}</td>
											</tr>
											<tr v-if="item.boxName">
												<th style="width: 8%">Caja</th>
												<td style="width: 15%">{{ item.boxCode }}</td>
												<td>{{ item.boxName }}</td>
											</tr>
											<tr v-if="item.bottleName">
												<th style="width: 8%">Botella</th>
												<td style="width: 15%">{{ item.bottleCode }}</td>
												<td>{{ item.bottleName }}</td>
											</tr>
										</thead>
									</table>
								</div>
								<div class="col-md-6">
									<table class="table table-striped table-hover table-bordered">
										<thead class="thead-light">
											<tr>
												<th style="width:25%">Obs. Preparación del Vino</th>
												<td>{{ item.preparationRemarks }}</td>
											</tr>
											<tr>
												<th>Glosa Sticker</th>
												<td>{{ item.stickerGloss }}</td>
											</tr>
											<tr>
												<th>Confección Packaging</th>
												<td>{{ item.confectionRemarks }}</td>
											</tr>
										</thead>
									</table>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Observaciones Adicionales</th>
											</tr>
											<tr v-if="item.requestDetailObservations">
												<th style="width: 18%">Fecha</th>
												<th style="width: 12%">Usuario</th>
												<th style="width: 70%">Observación</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="observation in item.requestDetailObservations"
												:key="observation.id">
												<td>{{ observation.createdAtString }}</td>
												<td>{{ observation.email }}</td>
												<td>{{ observation.observation }}</td>
											</tr>
											<tr>
												<td colspan="3">
													<div class="row">
														<div class="col-10">
															<input class="form-control"
																:id="'observation-input-' + item.id" type="text" />
														</div>
														<div class="col-2">
															<button class="btn btn-success float-right"
																@click="addObservation(item.id)">
																<i class="fa fa-save"></i>
																<span class="ml-2">Registrar Observación</span>
															</button>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="5">Documentos Adjuntos</th>
											</tr>
											<tr v-if="item.documentFiles.length > 0">
												<th style="width: 18%">Usuario</th>
												<th style="width: 12%">Fecha de Carga</th>
												<th style="width: 54%">Nombre del Archivo</th>
												<th style="width: 8%">Tipo de Archivo</th>
												<th style="width: 8%">Opciones</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="doc in item.documentFiles" :key="doc.id">
												<td>{{ doc.email }}</td>
												<td>{{ doc.createdAtString }}</td>
												<td>{{ doc.fileName }}</td>
												<td style="font-size: 20px">
													<span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
															aria-hidden="true" class="fas fa-file-pdf"></i></span>
													<span v-if="doc.fileExtension == '.jpg' ||
														doc.fileExtension == '.png'
													" class="text-info"><i aria-hidden="true" class="fas fa-image"></i></span>
													<span v-if="doc.fileExtension == '.xls' ||
														doc.fileExtension == '.xlsx'
													" class="text-success"><i aria-hidden="true" class="fas fa-file-excel"></i></span>
													<span v-if="doc.fileExtension == '.doc' ||
														doc.fileExtension == '.docx'
													" class="text-primary"><i class="fas fa-file-word"></i></span>
												</td>
												<td>
													<button class="btn btn-sm btn-success mr-2"
														@click="downloadFile(doc.id)">
														<i class="fa fa-download"></i>
													</button>
													<button class="btn btn-sm btn-danger" @click="deleteFile(doc.id)">
														<i class="fa fa-trash"></i>
													</button>
												</td>
											</tr>
											<tr v-if="!item.rejectToWinderyDispatch">
												<td colspan="4">
													<input :id="'file-input-' + item.id" type="file" />
												</td>
												<td>
													<button class="btn btn-sm btn-success" @click="uploadFile(item.id)">
														<i class="fa fa-save"></i>
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="row">
								<div v-if="item.inRevision" class="col-md-12">
									<table class="table table-stripped table-bordered">
										<thead class="thead-light">
											<tr>
												<th colspan="3">Historial de Revisión</th>
											</tr>
											<tr>
												<th style="width: 20%">Fecha de Envío a Revisión</th>
												<th style="width: 20%">Usuario</th>
												<th style="width: 60%">Razón</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="revision in item.requestChangeFlowHistories" :key="revision.id">
												<td>{{ revision.createdAtString }}</td>
												<td>{{ revision.user }}</td>
												<td>{{ revision.reason }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<alert v-else message="Aún no se registran muestras" />
		</card>
		<div class="text-center dmb-float-btn">
			<button v-if="details.length > 0 &&
				dispatch &&
				(status == 'Creado' || request.requiredRevisionCommercial)
			" class="btn btn-success btn-lg" @click="send">
				<i class="fas fa-paper-plane"></i> Enviar
			</button>
		</div>
		<modal-delete ref="modalDelete" @deleteItem="deleteItem" />
	</card>
</template>
<script>
import toastr from "toastr";
import $ from "jquery";
import { Delete, Get, Post, Put, GetSimple } from "../../../helper/axios";

export default {
	props: [
		"details",
		"id",
		"dispatch",
		"compositions",
		"status",
		"request",
	],
	data() {
		return {
			Delete,
			Post,
			Get,
			Put,
			GetSimple,
			apiUrl: this.$store.getters.apiUrl,
			deleteId: 0,
			editItem: {},
			detailId: 0,
			listComposition: [],
			modalTitle: "",
			Composition: {},
			checkedDispached: false,
		};
	},
	watch: {
		async editItem(val) {
			if (val.id > 0) {
				this.editItem.editId = this.editItem.id;
				this.editItem.composition = [];
				this.editItem.components = [];
				this.$store.commit("setLoading", true);

				try {
					if (val.requestTypeId === 1) {
						let compositionResponse = await this.GetSimple(this.apiUrl + "v1/compositions/" + this.editItem.id);
						compositionResponse.data.forEach((item) => {
							let composition = {
								id: item.id,
								variety: item.variety,
								percent: item.percent,
								RequestCommercialSampleDetailId: this.editItem.id,
							};
							this.editItem.composition.push(composition);
						});
					} else if (val.requestTypeId === 2 || val.requestTypeId === 3) {
						let componentsResponse = await this.GetSimple(this.apiUrl + "v1/selectedComponentsDetail/" + this.editItem.id);
						componentsResponse.data.forEach((item) => {
							let component = {
								sku: item.c_sku,
								saleZone: item.saleZone,
								name: item.name,
								componentPosition: item.componentPosition//pending
							};
							this.editItem.components.push(component);
						});
					}

					this.$store.commit("setLoading", false);
					this.$emit("copyItem", this.editItem);
				} catch (error) {
					this.$store.commit("setLoading", false);
				}
			}
		},
		deleteId(val) {
			if (val > 0) {
				this.showDeleteMessage();
			}
		},
	},
	methods: {
		showDeleteMessage() {
			this.$refs.modalDelete.show();
		},
		deleteItem() {
			this.Delete(
				`${this.apiUrl}v1/requestsample/${this.id}/details?detailId=${this.deleteId}`,
				() => {
					this.$emit("updateDetails", true);
					this.deleteId = 0;
					toastr.success("Se ha elimnado el registro solicitado");
				}
			);
		},
		cancelItem(id) {
			let cancel = false;
			this.$swal({
				title: "¿Desea Cancelar Muestra?",
				input: "text",
				text: "Si es así, debe ingresar el motivo de cancelación",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
			})
				.then((result) => {
					if (result.value) {
						let reason = result.value;
						this.$store.commit("setLoading", true);
						this.Put(
							this.apiUrl + "v1/canceldetail/" + id + "?reason=" + reason,
							() => {
								this.$store.commit("setLoading", false);
							}
						);
						cancel = true;
					}
				})
				.finally(() => {
					if (cancel) {
						let statusColor = document.getElementById("status-color-" + id);
						let statusText = document.getElementById("status-text-" + id);
						let optionHeader = $("#options-header-" + id);
						let optionButtons = $("#options-butons-" + id);
						statusColor.removeAttribute("class");
						statusColor.classList.add("ribbon");
						statusColor.classList.add("red");
						statusText.textContent = "Cancelado";
						optionHeader.hide();
						optionButtons.hide();
						this.$swal.fire(
							"Cancelado!",
							"La solicitud ha sido cancelada correctamente."
						);
						this.$store.commit("setLoading", false);
					}
					this.$store.commit("setLoading", false);
				});
		},
		send() {
			this.$store.commit("setLoading", true);
			this.Post(`${this.apiUrl}v1/requestsample/${this.id}/send`, {}, () => {
				this.$store.commit("setLoading", false);
				window.toastr.success("Se ha enviado la solicitud correctamente.");
				//this.$router.push("/");
				location.reload();
			});
		},
		uploadFile(detailId) {
			let form = new FormData();
			let doc = document.getElementById("file-input-" + detailId);
			form.append("detailId", detailId);
			if (doc) {
				doc = doc.files[0];
				form.append("fileBase", doc);
			}
			this.$store.commit("setLoading", true);
			this.Put(`${this.apiUrl}v1/documentfile`, form, () => {
				this.$store.commit("setLoading", false);
				window.toastr.success("Se ha cargado el documento correctamente.");
				location.reload();
			});
		},
		addObservation(detailId) {
			this.$store.commit("setLoading", true);
			let obs = document.getElementById("observation-input-" + detailId);
			let data = {
				requestCommercialSampleDetailId: detailId,
				observation: obs.value
			};
			this.Post(`${this.apiUrl}v1/RequestDetailObservations`, data, () => {
				this.$store.commit("setLoading", false);
				window.toastr.success("Se ha registrado la Observación correctamente.");
				this.$emit('updateObservations')
				obs.value = '';
			});
		},
		downloadFile(id) {
			window.open(`${this.apiUrl}v1/documentfile/${id}`);
		},
		deleteFile(documentId) {
			this.$swal({
				title: "¿Desea eliminar archivo de la muestra?",
				text: name,
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
			}).then((result) => {
				if (result.value) {
					this.Delete(this.apiUrl + "v1/documentfile/" + documentId, () => {
						window.toastr.success("Archivo Eliminado correctamente.");
						location.reload();
					});
				}
			});
		},
	},
	computed: {
		detailNew: function () {
			return this.details.filter((x) => x.requestTypeId === 1);
		},
		detailFinish: function () {
			return this.details.filter((x) => x.requestTypeId === 2);
		},
		detailBottle: function () {
			return this.details.filter((x) => x.requestTypeId === 3);
		},
		compositionFilter: function () {
			return this.composition.filter(
				(x) => x.requestCommercialSampleDetailID === this.item.id
			);
		},
	},
};
</script>
